import { EnrollmentContext } from "@/state";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

export const useConsistentClient = () => {
  const [state] = useContext(EnrollmentContext);
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const clientName = searchParams.get("client");
  const enrollmentPlan = searchParams.get("enrollmentPlan");

  useEffect(() => {
    const plans = state.experienceData.plan_csids;
    const planOnClient = plans.some((plan) => plan.id === Number(enrollmentPlan));

    if (!planOnClient && clientName) navigate(`/?client=${clientName}`);
  }, [navigate, clientName, enrollmentPlan, state?.experienceData]);
};
